<template>
  <div @contextmenu.prevent>
    <vue-video-player class="vjs-custom-skin"
      v-if="src"
      ref="video_block"
      @play="unlock_params"
      @pause="$emit('paused')"
      @ready="init"
      @ended="ended"
      :options="player_options">
    </vue-video-player>
  </div>
</template>

<script>
import { videoPlayer } from 'vue-video-player'

export default {
  name: 'player',
  components: {
    VueVideoPlayer: videoPlayer
  },
  props: {
    src: {
      type: [String],
      default: ''
    },
    muted: {
      type: Boolean,
      default: false
    },
    volume: {
      type: Number,
      default: 1
    },
    rate: {
      type: Number,
      default: 1
    },
    index: {
      type: Number,
      default: 0
    },
    options: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      player: null,
      height: 0,
      default_options: {
        playbackRates: [1.0, 1.25, 1.5, 2.0],
        fluid: false,
        height: this.height,
        playsinline: true,
        muted: true,
        sources: [
          {type: 'video/mp4', src: this.src}
        ]
      }
    }
  },
  computed: {
    player_options() {
      return Object.assign({}, this.default_options, this.custom_options);
    }
  },
  methods: {
    init(player) {
      // сохраняем объект плеера и подписываемся на события, чтобы передать параметры для других запусков
      this.player = player;
      this.player.on('ratechange', () => {
        this.$emit('changed', {
          volume: this.volume,
          muted: this.muted,
          rate: this.player.playbackRate()
        })
      });
      this.player.on('volumechange', () => {
        this.$emit('changed', {
          volume: this.player.volume(),
          muted: this.player.muted(),
          rate: this.rate
        })
      });
      this.$emit('ready', this.player);
    },
    unlock_params(player) {
      // выставляем сохраненые параметры
      player.volume(this.volume);
      player.muted(this.muted);
      player.playbackRate(this.rate);
      this.$emit('play');
    },
    play(time) {
      if(this.player === null) {
        return null;
      }
      if(time !== undefined) {
        this.player.currentTime(time);
      }
      this.player.play();
    },
    pause() {
      if(this.player === null) {
        return null;
      }
      this.player.pause();
    },
    ended() {
      if(this.player.isFullscreen_) {
        this.player.exitFullscreen();
      }
      this.$emit('ended');
    },
    play_pause(time) {
      if(this.player === null) {
        return null;
      }
      // проверяем статус плеера и делаем инверсионное действие
      if(this.player.paused()) {
        this.play(time);
      } else {
        this.pause();
      }
    }
  },
  created() {
    // Трансфер контролов плеером, методы которыми можно управлять плеером
    this.$emit('inited', {
      play: this.play,
      pause: this.pause,
      play_pause: this.play_pause,
      index: this.index
    });
  },
  mounted() {
    let h = this.$refs.video_block.$el.clientWidth * 3 / 4;
    if(h > 427) {
      this.height = 427;
    } else {
      this.height = h;
    }
    // this.vrdy();
  }
}
</script>
